const MAIN = 'Diagnostic Images';

export const LABELS = {
    DASHBOARD_BUTTON: MAIN,
    BREAD_CRUMB: MAIN,
    PAGE_TITLE: MAIN,
    TYPE: 'Type',
    DATE: 'Date',
};
